import * as React from 'react';
import { Field, reduxForm, change } from 'redux-form';
//import DEform from '../forms/DEform';
import styles from './deFormStyles';
import { TouchableOpacity, ScrollView } from 'react-native';
import { Container, Header, InputGroup, Content, Text, Label, Picker, Item, Card, CardItem, Input, Icon, Toast, Form, Spinner, View, Left, Right, Body, Button, Title } from 'native-base';

//import * as _ from 'lodash';

import customValidate from './validators';

import { textInput, moneyInput, renderPicker, renderDateField } from './renderedComponents';

const upper = value => value && value.toUpperCase();

function syncValidate(values, props) {
	//runs while field changing
	const errors = {};

	//if(parseFloat(values.paid)>0 && values.account_id==0) errors.account_id='Please select an account';

	return errors;
}

function personAsyncValidate(values, dispatch, props, field) {
	//changes to this func will not show in live refresh
	return new Promise((resolve, reject) => {
		const val = values[field];
		if (field == 'openingDebt') {
			var value = Number(val);
			var Dispval = parseFloat(isNaN(value) ? 0 : value).toFixed(2);
		}
		if (field == 'postCode') {
			var postcode_regex = /([A-Z]{1,2}[0-9][0-9A-Z]?)\s?([0-9][A-Z]{2})/i;
			var postcodeBits = val.match(postcode_regex);
			var Dispval = postcodeBits.length ? postcodeBits[1].toUpperCase() + ' ' + postcodeBits[2].toUpperCase() : val;
		}
		__DEV__ && console.log('changing ', field, Dispval);
		dispatch(change('PersonForm', field, Dispval));

		resolve();
	});
}

class PersonForm extends React.Component {
	constructor(props) {
		super(props);

		this.initialState = { fullForm: false, showAddress: false, showContact: false };
		this.state = this.initialState;
		this.formRefs = [];
	}

	componentDidMount() {}

	_changeFormVal(field, val) {
		__DEV__ && console.log('setting ', field, val);
		this.props.dispatch(change('DEform', field, val));
	}

	render() {
		const { handleSubmit, pristine, reset, submitting, submit, isNew, submitSucceeded } = this.props;
		const { moreDetails, showAddress, showContact } = this.state;
		//if submitSucceeded close the popup
		//if (submitSucceeded) this.props.toClose();
		/*
			contact name, business, openingDebt, address1, 2, city, postcode, email, tel, notes
			*/

		return (
			<View style={{ flex: 1, backgroundColor: '#EEE', width: '100%', borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>
				<Header style={{ height: 45, borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>
					{!pristine && (
						<Button transparent onPress={() => this.props.toClose()}>
							<Icon name="close" />
						</Button>
					)}
					<Body>
						<Title>
							{isNew ? 'New' : 'Edit'} {this.props.personType}
						</Title>
					</Body>
					<Right>
						{submitting ? (
							<Spinner />
						) : (
							<Button transparent onPress={this.props.submit}>
								<Icon name={pristine && !isNew ? 'arrow-dropdown' : 'checkmark'} />
							</Button>
						)}
					</Right>
				</Header>
				<Content>
					<Form onSubmit={handleSubmit} style={{ margin: 5, flex: 1, backgroundColor: '#EEE' }}>
						<Card style={{ paddingHorizontal: 3, paddingBottom: 5 }}>
							<CardItem header bordered>
								<Text>🏭 Details</Text>
							</CardItem>

							<Field name="name" labelType="inline" label="👤" placeholder="Contact Name" component={textInput} />
							{isNew && !moreDetails ? (
								<Button transparent iconLeft onPress={() => this.setState({ moreDetails: true })}>
									<Icon name="add-circle" />
									<Text>More Details</Text>
								</Button>
							) : (
								<>
									<Field name="businessName" labelType="inline" label="🚩" placeholder="Business Name" component={textInput} />
									<Field name="openingDebt" labelType="inline" label="Opening Debt" component={moneyInput} />
									<Field name="notes" placeholder="Notes for your reference" labelType="inline" component={textInput} />
								</>
							)}
						</Card>
						<Card style={{ paddingHorizontal: 3, paddingBottom: 5 }}>
							{isNew && !showAddress ? (
								<Button transparent iconLeft onPress={() => this.setState({ showAddress: true })}>
									<Icon name="add-circle" />
									<Text>Address</Text>
								</Button>
							) : (
								<>
									<CardItem header bordered>
										<Text>🏢 Address</Text>
									</CardItem>
									<Field name="address1" labelType="inline" label=" " placeholder="Address" component={textInput} />
									<Field name="address2" labelType="inline" label=" " placeholder="Address Line 2" component={textInput} />
									<Field name="city" labelType="inline" label=" " placeholder="Town" component={textInput} />
									<Field name="postCode" labelType="inline" label=" " validate={[customValidate]} placeholder="Postcode" component={textInput} />
								</>
							)}
						</Card>
						<Card style={{ paddingHorizontal: 3, paddingBottom: 5 }}>
							{isNew && !showContact ? (
								<Button transparent iconLeft onPress={() => this.setState({ showContact: true })}>
									<Icon name="add-circle" />
									<Text>Phone / email</Text>
								</Button>
							) : (
								<>
									<CardItem header bordered>
										<Text>📞 Contact Details</Text>
									</CardItem>
									<Field name="tel" labelType="inline" validate={[customValidate]} keyboardType={'phone-pad'} label="☎" component={textInput} placeholder="Phone" />

									<Field name="email" labelType="inline" validate={[customValidate]} keyboardType={'email-address'} label="📧" component={textInput} placeholder="Email" />
								</>
							)}
						</Card>
					</Form>
				</Content>
			</View>
		);
	}
}

export default reduxForm({
	form: 'PersonForm',
	validate: syncValidate,
	asyncValidate: personAsyncValidate,
	asyncBlurFields: ['openingDebt', 'postCode'] //cause a re-render
})(PersonForm);
